import styled from 'styled-components';

export const AllClassToggle = styled.a`
  font-size: 13px;
`;

export const Wrapper = styled.div`
  margin: 24px 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  flex-flow: row wrap;
  width: 100%;
  position: relative;
  padding-left: 24px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
`;

export const LabelToggleWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-left: -5px;
  font-size: 14px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 30px;
  margin-right: 16px;
`;

export const VisibilityToggleWrapper = styled.div`
  position: absolute;
  top: 7px;
  left: 0;
`;

export const SearchWrapper = styled.div`
  margin-left: -14px;
`;
